import Slider from '../modules/slider';
import OrderItem from '../modules/order-item';
import Product from '../modules/product';
import { popupOpen, popupClose } from '../utils/index';

/* preview gallery slider */
const previewGallerySlider = new Slider('[data-ui-el="preview-slider"]', {
    direction: 'horizontal',
    slidesPerView: 'auto',
    speed: 400,
    spaceBetween: 6,
    freeMode: true,
    watchSlidesProgress: true,

    breakpoints: {
        320: {
            direction: 'horizontal',
            spaceBetween: 6,
        },
        480: {
            direction: 'horizontal',
            spaceBetween: 8,
        },
        768: {
            direction: 'vertical',
            spaceBetween: 8,
        },
    },
});

/* product gallery slider */
const productGallerySlider = new Slider('[data-ui-el="product-gallery-slider"]', {
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 400,
    passiveListeners: false,
    touchStartPreventDefault: false,

    zoom: {
        maxRatio: 2,
        minRatio: 1,
    },

    thumbs: {
        swiper: previewGallerySlider.swiper,
        autoScrollOffset: 0,
    },

    navigation: {
        nextEl: '[data-ui-el="gallery-btn-next"]',
        prevEl: '[data-ui-el="gallery-btn-prev"]',
    },

    pagination: {
        el: '.gallery-product__pagination',
        type: 'bullets',
        bulletElement: 'button',
        clickable: true,
    },

    on: {
        touchStart: function (e) {
            const currentSlide = this.slides[this.activeIndex];

            if (currentSlide.hasAttribute('data-model-src')) {
                this.allowTouchMove = false;
            } else {
                this.allowTouchMove = true;
            }
        },
    },
});

/* gallery slider zoom */
const md3Below = window.matchMedia('(max-width: 768px)');

if (productGallerySlider.swiper) {
    if (productGallerySlider.swiper.slides.length < 2) {
        productGallerySlider.sliderBlocking();
    }

    productGallerySlider.swiper.on('zoomChange', function (swiper, scale, image, slide) {
        if (scale === 1) {
            if (swiper.slides.length > 1) {
                this.allowTouchMove = true;
            }

            image.style.cursor = 'zoom-in';
            return;
        }

        this.allowTouchMove = false;
        image.style.cursor = 'zoom-out';
    });

    window.addEventListener('click', (event) => {
        if (event.target.closest('.swiper-zoom-container')) {
            return;
        }

        productGallerySlider.swiper.zoom.out();
    });

    productGallerySlider.domElArr.forEach((slider) => {
        let mouseX = 0,
                mouseY = 0;

        slider.addEventListener('mousedown', (event) => {
            mouseX = event.clientX;
            mouseY = event.clientY;
        });

        slider.addEventListener('mouseup', (event) => {
            const { target, button, clientX, clientY } = event;
            const isMouseMoved = Math.abs(mouseX - clientX) > 3 || Math.abs(mouseY - clientY) > 3;

            if (button !== 0 || md3Below.matches || isMouseMoved) {
                return;
            }

            if (target.closest('.swiper-zoom-container')) {
                productGallerySlider.swiper.zoom.toggle(event);
            }
        });
    });
}

/* product size table adaptive */
const sizeBody = document.querySelector('[data-adaptive="size-body"]');

if (sizeBody) {
    const sizeChart = document.querySelector('[data-adaptive="size-chart"]');
    const gallery = document.querySelector('[data-adaptive="gallery"]');
    const { scrollWidth } = sizeBody;
    const { offsetWidth } = sizeChart;

    if ((scrollWidth - offsetWidth) > 0) {
        gallery.style.gridRow = '1';
        sizeChart.style.gridColumn = '1 / 3';
    }
}

/* product description */
const productDescrBlock = document.querySelector('[data-ui-el="text-overflow"]');

if (productDescrBlock) {
    const maxSize = 400;
    const textContent = productDescrBlock.innerHTML.trim();
    const showBtn = document.querySelector('[data-btn="show-more"]');

    if (textContent.length > maxSize) {
        const showMoreText = showBtn.dataset.showMore;
        const showLessText = showBtn.dataset.showLess;

        productDescrBlock.innerHTML = textContent.slice(0, maxSize) + '...';
        showBtn.style.visibility = 'visible';

        showBtn.addEventListener('click', function () {

            if (this.innerHTML === showMoreText) {
                productDescrBlock.innerHTML = textContent;
                this.innerHTML = showLessText;
                return;
            }

            productDescrBlock.innerHTML = textContent.slice(0, maxSize) + '...';
            this.innerHTML = showMoreText;
        });
    } else {
        showBtn.style.display = 'none';
    }
}

/* products sliders */
const productsSlider = new Slider('[data-ui-el="product-slider"]', {
    loop: true,
    loopPreventsSlide: true,
    slidesPerView: 3,
    watchSlidesProgress: true,
    watchVisibleSlides: true,
    preloadImages: true,
    slidesOffsetBefore: 1,
    centerInsufficientSlides: true,
    freeMode: true,

    breakpoints: {
        360: {
            slidesPerView: 1.7,
            spaceBetween: 16,
        },
        480: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 24,
        },
    },

    navigation: {
        nextEl: '[data-ui-el="btn-next"]',
        prevEl: '[data-ui-el="btn-prev"]',
    },
}, true);

const productVideo = document.querySelector('[data-video="product-video"]');
const playVideoBtn = document.querySelector('[data-btn="play-video"]');

if (productVideo) {
    playVideoBtn.addEventListener('click', (event) => {
        playVideoBtn.style.display = 'none';
        productVideo.controls = true;
        productVideo.play();
    });
}

const preorderPopup = document.querySelector('#preorder');

if (preorderPopup) {
    const preorderForm = preorderPopup.querySelector('[data-ui-el="preorder-form"]');
    const preorderItem = new OrderItem(preorderForm);

    preorderPopup.addEventListener('popup-open', (event) => {
        const { target } = event;
        const product = new Product();

        if (product.activeSize.name) {
            target.querySelector('[data-ui-el="size_name"]').innerHTML = product.activeSize.name;
            target.querySelector('input[name="size_id"]').value = product.activeSize.id;
        } else {
            target.querySelector('[data-ui-el="size_name"]')?.parentElement.remove();
        }

        target.querySelector('[data-preorder="prices"]').innerHTML = document.querySelector('[data-product="prices"]').innerHTML;
        preorderItem.quantityDom.input.max = product.activeSize.quantity;
        preorderItem.setMaxQuantity(parseInt(product.activeSize.quantity, 10));
        preorderItem.productQuantity = parseInt(product.currentQuantity, 10);
        preorderItem.setInputQuantity();
        preorderItem.checkQuantityValue();
        target.querySelector(`input[value="${product.activePrice}"]`).checked = true;
    });

    preorderForm.addEventListener('submit', (event) => {
        event.preventDefault();
        preorderRequestHandler(preorderForm);
    });
}

async function preorderRequestHandler(form = null) {
    if (!form) return;

    try {
        const response = await fetch(form.action, {
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            },
            body: new FormData(form),
        });

        if (!response.ok) {
            throw new Error(response.statusText);
        }

        const result = await response.json();

        if (result.status) {
            const resultPopup = document.querySelector('#preorder-result');
            popupClose(preorderPopup);
            popupOpen(resultPopup);
        }
    } catch (err) {
        console.log('Error: ', err);
    }
}
